import React from "react";
import "./divider.css";
import classNames from "classnames";

function Divider(props) {
  const { className } = props;
  return <hr className={classNames("divider", className)} />;
}

export default Divider;
